import type { IconData } from '@stacksjs/iconify-core'

export const layerMaskSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M7.416 6.078C10.418 5.794 15.561 5.5 24 5.5s13.582.294 16.584.578c2.925.277 5.117 2.486 5.406 5.396c.256 2.578.51 6.62.51 12.526s-.254 9.948-.51 12.526c-.29 2.91-2.481 5.119-5.406 5.396c-3.002.284-8.145.578-16.584.578s-13.582-.294-16.584-.578c-2.925-.277-5.117-2.486-5.406-5.396c-.256-2.578-.51-6.62-.51-12.526s.254-9.948.51-12.526c.29-2.91 2.481-5.119 5.406-5.396M34 24c0-5.523-4.477-10-10-10s-10 4.477-10 10s4.477 10 10 10s10-4.477 10-10\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default layerMaskSolid
